<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid ? submit() : ''" ref="form">
                <switch-input v-model="department.status" label="وضعیت دپارتمان"></switch-input>
                <switch-input v-model="department.visibility" label="نمایش برای مشتریان"></switch-input>
                <v-text-field
                    :rules="$validation('required')"
                    label="* عنوان"
                    v-model="department.name"
                ></v-text-field>
                <v-text-field
                    :rules="$validation()"
                    v-if="$system.license.features.satisfaction_survay"
                    label="آدرس فرم نظرسنجی"
                    v-model="department.survey_link"
                ></v-text-field>
                <v-textarea
                    :rules="$validation()"
                    no-resize
                    rows="3"
                    label="توضیحات"
                    model-value=""
                    v-model="department.description"
                ></v-textarea>
                <v-autocomplete
                    :rules="[
                        ...$validation('required'),
                        (v) => v < 2 || !v.some(x => workingshifts.find(y => y.id == x).conflicts.some(y => v.includes(y))) || 'شیفت های کاری با هم تداخل دارند'
                    ]"
                    :items="workingshifts"
                    v-if="$system.license.features.workingshift"
                    v-model="department.workingshifts"
                    item-title="name"
                    item-value="id"
                    label="* شیفت‌های کاری"
                    no-data-text="موردی پیدا نشد!"
                    multiple
                ></v-autocomplete>
                <div class="mt-4">
                    <v-btn type="submit" color="success" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn class="ms-3" variant="text" color="error" @click="$router.push({path: '/departments'});" :disabled="loading">بازگشت</v-btn>
                </div>
                <p class="text-small text-grey-darken-1 mt-3">پس از ایجاد دپارتمان امکان مدیریت کاربران سازمانی وجود دارد.</p>
            </v-form>
        </v-col>
    </div>
</template>

<script>
export default {
    title: "ایجاد",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            department: {
                name: null,
                survey_link: null,
                description: null,
                workingshifts: [],
                status: true,
                visibility: true,
            },
            workingshifts: [],
        };
    },
    methods: {
        submit() {
            this.loading = true;
            let form = {...this.department};
            if(!this.$system.license.features.satisfaction_survay)
                delete form.survey_link;
            this.$departmentStore(form).then(async (res) => {
                if (res && res.status == "CREATED") {
                    this.$toast.success(res.message);
                    this.$auth.fetchUser(true);
                    this.$system.setSystemDefaults(true);
                    this.$system.setAdminDefaults(true);
                    this.$router.push({path: '/departments'});
                }
            }).finally(()=>{this.loading = false});
        },
    },
    async mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            if (this.$system.license.features.workingshift) {
                await this.$system.setWorkingshifts();
                this.workingshifts = this.$system.workingshifts;
            }
            this.$loading.finish();
        });
    },
};
</script>
